import { useDispatch, useSelector } from "react-redux";
import { useLayoutEffect, useCallback } from "react";
import { setLang } from "../redux/appConfig/actions";
import { jsonParse, jsonStringify } from "../helper/common";

const STORE_LANG_DATA_KEY = "__lang_data__";
const useLocalization = () => {
  const dispatch = useDispatch();
  const translations = useSelector((store) => store?.appConfig?.lang);

  const translate = useCallback(
    (key) => {
      return translations?.[key] || key;
    },
    [translations]
  );

  useLayoutEffect(() => {
    setLocalLangData();
    // find with window
    window.langTranslate = translate;
  }, [dispatch]);

  function setLocalLangData() {
    const savedLangData = localStorage.getItem(STORE_LANG_DATA_KEY);
    if (savedLangData) {
      const parsedData = jsonParse(savedLangData);
      dispatch(setLang(parsedData));
    }
  }

  const loadLanguage = useCallback(
    async (lang = "EN") => {
      const url = `/assets/locales/${lang}.json`;

      try {
        const res = await fetch(url);
        const data = await res.json();
        localStorage.setItem(STORE_LANG_DATA_KEY, jsonStringify(data));
        dispatch(setLang(data));
      } catch (error) {
        console.warn(
          `Network fetch failed for ${lang}.json. Trying cache...`,
          error
        );

        // Fallback to service worker cache
        if ("caches" in window) {
          try {
            const cache = await caches.open("locale-files");
            const cachedResponse = await cache.match(url);
            if (cachedResponse) {
              const data = await cachedResponse.json();
              dispatch(setLang(data));
            } else {
              console.error(`No cached version found for ${lang}.json`);
            }
          } catch (cacheError) {
            console.error("Error accessing cache:", cacheError);
          }
        }
      }
    },
    [dispatch]
  );

  const changeLanguage = useCallback(
    (lang) => {
      loadLanguage(lang);
    },
    [loadLanguage]
  );

  return {
    translate,
    changeLanguage,
    loadLanguage,
    setLocalLangData,
  };
};

export default useLocalization;
